module.exports = __webpack_public_path__ + "assets/img/center.3facc89c.svg";